module.exports = __webpack_public_path__ + "img/store-prozis-points.1e166a4c.svg";